import { render, staticRenderFns } from "./cooprationDialog.vue?vue&type=template&id=47b9d142&scoped=true"
import script from "./cooprationDialog.vue?vue&type=script&lang=js"
export * from "./cooprationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9d142",
  null
  
)

export default component.exports